document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.resource-list__carousel').forEach(carousel => {
    const track = carousel.querySelector('slideshow-slides');
    if (!track) return;

    if (getComputedStyle(carousel).display === 'block') return;

    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'position:relative;width:30%;height:2px;background:#e8e8e8;border-radius:999px;margin-top:32px;margin-left:auto;margin-right:auto;overflow:hidden;';

    const bar = document.createElement('div');
    bar.style.cssText = 'position:absolute;top:0;left:0;height:2px;background:#111;border-radius:999px;transition:width 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), left 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);width:15%;';

    wrapper.appendChild(bar);
    carousel.parentElement.appendChild(wrapper);

    const updateBar = () => {
      const scrollable = track.scrollWidth - track.clientWidth;
      if (scrollable <= 0) {
        bar.style.left = '0%';
        return;
      }
      const progress = track.scrollLeft / scrollable;
      bar.style.left = (progress * 85) + '%';
    };

    track.addEventListener('scroll', updateBar);
    updateBar();
  });
});